var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "50%",
      disabledSave: !!(_vm.model.id && _vm.model.term_signature_status_id == 2),
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-teacher", {
                          attrs: {
                            model: _vm.model.teacher_ids,
                            data:
                              _vm.model.id && _vm.model.teacher
                                ? _vm.model.teacher
                                : null,
                            error:
                              _vm.errors.teacher_ids && _vm.errors.length > 0,
                            errors: _vm.errors.teacher_ids,
                            label: "Professor(es)*",
                            autoComplete: "",
                            multiple: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "teacher_ids", $event)
                            },
                          },
                        }),
                        _c("span", { staticClass: "caption grey--text" }, [
                          _vm._v("Selecione um ou mais professores"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("sys-select-term", {
                          attrs: {
                            model: _vm.modelTermIds,
                            data:
                              _vm.model.id && _vm.model.term
                                ? _vm.model.term
                                : null,
                            error:
                              _vm.errors.term_ids &&
                              _vm.errors.term_ids.length > 0,
                            errors: _vm.errors.term_ids,
                            label: "Termo(s)*",
                            autoComplete: "",
                            multiple: !_vm.model.id,
                          },
                          on: {
                            "update:model": function ($event) {
                              _vm.modelTermIds = $event
                            },
                          },
                        }),
                        !_vm.model.id
                          ? _c("span", { staticClass: "caption grey--text" }, [
                              _vm._v("Selecione um ou mais termos"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.model.id
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("sys-select-term-signature-status", {
                              attrs: {
                                model: _vm.model.term_signature_status_id,
                                error:
                                  _vm.errors.term_signature_status_id &&
                                  _vm.errors.length > 0,
                                errors: _vm.errors.term_signature_status_id,
                                label: "Status*",
                                autoComplete: "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(
                                    _vm.model,
                                    "term_signature_status_id",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("v-switch", {
                              staticClass: "mt-0",
                              attrs: {
                                label: "Enviar imediatamente",
                                disabled:
                                  !_vm.model.teacher_ids ||
                                  _vm.model.teacher_ids.length > 1,
                                inset: "",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.model.send_immediately,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "send_immediately", $$v)
                                },
                                expression: "model.send_immediately",
                              },
                            }),
                            _c("span", { staticClass: "caption grey--text" }, [
                              _vm._v(
                                " Se desligado, o termo fica pendente de envio e poderá ser enviado em lote depois. "
                              ),
                            ]),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.note,
                            "error-messages": _vm.errors.note,
                            label: "Observação",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.model.note,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "note", $$v)
                            },
                            expression: "model.note",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.note_user,
                            "error-messages": _vm.errors.note_user,
                            label: "Observação do Usuário",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.model.note_user,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "note_user", $$v)
                            },
                            expression: "model.note_user",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }